@if (target) {
  <div class="container-fluid">
    <div class="position-relative">
      <h1 class="h1-admin">{{ title }}</h1>
      @if (canCreateTasks) {
        <div class="btn-new-tache">
          <button mat-raised-button color="accent" (click)="createTask()">
            {{ wording?.creationButtonLabel ?? 'Créer un nouvel évènement' }}
          </button>
        </div>
      }
    </div>
    <mat-tab-group class="bg-white label-tab-minimal tab-content-no-padding" mat-stretch-tabs="false">
      <mat-tab label="En cours">
        <mat-card>
          <mat-card-content>
            <app-tasks-list
              [action]="action"
              [target]="target"
              [showCompletedTasks]="false"
              [version]="version"
            (taskCompleted)="historique.loadActivities()"></app-tasks-list>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="Historique">
        <mat-card>
          <mat-card-content>
            <app-log #historique [target]="target" [showTasks]="false" [showOriginDateTime]="true"></app-log>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </div>
}
